import { useStacklineTheme } from '@stackline/ui';
import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { ViewRowIcon, ViewTileIcon, NewBeaconExportIcon } from 'src/components/SvgIcons';

export enum GridView {
  Tile = 'tile',
  Table = 'table'
}
export interface GridButtonGroupBaseProps {
  icons?: {
    export?: boolean;
    tile?: boolean;
    table?: boolean;
  };
  selectedView?: GridView;
  onChangeView?: (view: GridView) => void;
  onExport?: () => void;
}

export const GridButtonGroupBase = ({ icons = {}, selectedView, onChangeView, onExport }: GridButtonGroupBaseProps) => {
  const theme = useStacklineTheme();

  return (
    <Flex gap="sm">
      {icons.export && (
        <NewBeaconExportIcon width="24px" height="24px" style={{ cursor: 'pointer' }} onClick={() => onExport?.()} />
      )}
      {icons.tile && (
        <ViewTileIcon
          width="24px"
          height="24px"
          fill={selectedView === GridView.Tile ? '#000' : '#6B6B6B'}
          style={{
            fill: theme.colors.primary,
            opacity: selectedView === GridView.Tile ? 1 : 0.2,
            cursor: 'pointer'
          }}
          onClick={() => onChangeView?.(GridView.Tile)}
        />
      )}
      {icons.table && (
        <ViewRowIcon
          width="24px"
          height="24px"
          style={{
            fill: theme.colors.primary,
            opacity: selectedView === GridView.Table ? 1 : 0.2,
            cursor: 'pointer'
          }}
          onClick={() => onChangeView?.(GridView.Table)}
        />
      )}
    </Flex>
  );
};
